import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import {getCourseLabel} from '../../../../../utils/entity/course';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {actor, course, program, subgoal} = contexts;

  const courseLabel = getCourseLabel(course);

  return {
    avatar: program?.avatar,
    avatarPlaceholder: program?.title,

    subAvatar: actor?.avatar,
    subAvatarPlaceholder: actor?.name,

    title: i18n.t('notifications:subgoal_reached.title', {
      actorName: actor?.name,
      courseDates: courseLabel ? `(${courseLabel})` : '',
      programTitle: program?.title,
      subgoalTitle: subgoal?.title,
    }),
  };
};
